module.exports = __webpack_public_path__ + "img/76_11.40520faa.png";